import { useEffect, useRef, useState } from 'react';

export default function EducationSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const educationCards = [
    {
      type: 'large',
      icon: 'ri-graduation-cap-line',
      iconBg: 'bg-[#3B82F6]/20',
      iconColor: 'text-[#3B82F6]',
      title: 'МИРЭА — РТУ',
      subtitle: 'Програмиране',
      description: 'Инженерната база позволява прилагане на алгоритмичен подход, анализ на големи масиви от данни и изграждане на структурирани инвестиционни модели.',
    },
    {
      type: 'small',
      icon: 'ri-award-line',
      iconBg: 'bg-[#D4AF37]/20',
      iconColor: 'text-[#D4AF37]',
      title: 'Професионален участник',
      subtitle: 'от 2016 година',
      description: '',
    },
    {
      type: 'medium',
      icon: 'ri-building-line',
      iconBg: 'bg-[#0A1628]',
      iconColor: 'text-[#D4AF37]',
      title: 'London Business School',
      subtitle: 'Инвестиционни рискове и управление на портфейл',
      description: 'Международната подготовка засили компетенциите в областта на глобалните пазари, макроикономиката и институционалните стратегии.',
    },
    {
      type: 'small',
      icon: 'ri-bar-chart-box-line',
      iconBg: 'bg-[#D4AF37]/20',
      iconColor: 'text-[#D4AF37]',
      title: 'Количествен анализ',
      subtitle: '',
      description: 'Прилагане на математически модели и статистически методи за оценка на рисковете и доходността.',
    },
    {
      type: 'large',
      icon: 'ri-briefcase-line',
      iconBg: 'bg-[#D4AF37]/20',
      iconColor: 'text-[#D4AF37]',
      title: 'Управление на портфейл',
      subtitle: '',
      description: 'Стратегическо планиране и оптимизация на инвестиционни портфейли съобразно целите на клиента, времевия хоризонт и толерантността към риск. Редовно ребалансиране и мониторинг на ефективността.',
    },
    {
      type: 'medium',
      icon: 'ri-earth-line',
      iconBg: 'bg-[#D4AF37]/20',
      iconColor: 'text-[#D4AF37]',
      title: 'Глобални пазари',
      subtitle: '',
      description: 'Задълбочено разбиране на макроикономическите процеси и тяхното влияние върху различни класове активи в международен контекст.',
    },
  ];

  return (
    <section
      ref={sectionRef}
      className="relative py-24 lg:py-32 bg-[#F8F9FA]"
    >
      <div className="container mx-auto px-6 lg:px-12">
        {/* Label */}
        <div className="mb-6">
          <span className="text-sm uppercase tracking-[3px] text-[#D4AF37] font-semibold">
            Образование
          </span>
        </div>

        {/* Title */}
        <h2 
          className={`text-4xl lg:text-5xl font-bold text-[#0A1628] mb-16 max-w-4xl font-['Playfair_Display'] transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Техническа база и бизнес школа от световна класа
        </h2>

        {/* Masonry grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {educationCards.map((card, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl p-8 shadow-lg transition-all duration-700 hover:-translate-y-2 hover:shadow-2xl cursor-pointer ${
                card.type === 'large' ? 'md:row-span-2' : card.type === 'medium' ? 'md:row-span-1' : ''
              } ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className={`w-14 h-14 ${card.iconBg} rounded-full flex items-center justify-center mb-6`}>
                <i className={`${card.icon} text-3xl ${card.iconColor}`}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#0A1628] mb-2 font-['Playfair_Display']">
                {card.title}
              </h3>
              {card.subtitle && (
                <p className="text-sm text-[#6B7280] mb-3 font-['Inter']">
                  {card.subtitle}
                </p>
              )}
              {card.description && (
                <p className="text-base text-[#4B5563] leading-relaxed font-['Inter']">
                  {card.description}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
